module.exports = __webpack_public_path__ + "static/media/رحلات الى سويسرا.5c37e238.jpg";